import classNames from "classnames"
import React from "react"

import { extractFromTag, getThemeColor } from "./utils"
import GatsbyStoryblokImage from "../../../elements/V2/GatsbyStoryblokImage"
import Typography from "../../../elements/V2/Typography"

import { TableRegex } from "@constants/tables"

const CELL_TEXT_CLASSSES =
  "[display:-webkit-box] [-webkit-box-orient:vertical] text-start"

type HeaderDropdownProps = {
  availableColumns: number[]
  data: string[][]
  columnImages?: string[]
  displayIndex: number
  selectedColumnsLength: number
  theme: "light" | "dark"
  onSelectColumn: (columnIndex: number) => void
}

const HeaderDropdown = ({
  availableColumns,
  data,
  columnImages,
  displayIndex,
  selectedColumnsLength,
  theme,
  onSelectColumn,
}: HeaderDropdownProps) => {
  return (
    <div
      className={classNames(
        "absolute z-20 -mt-0.5 flex w-1/2 flex-col rounded-b-10 !border-t-0 shadow-lg sm:w-[calc(33.333%-10.667px)] sm:border md:w-[calc(33.333%-21.333px)]",
        theme === "light"
          ? "border-charcoal/10 bg-white"
          : "border-charcoal bg-black",
        {
          "left-0": displayIndex === 0,
          "right-0": displayIndex === selectedColumnsLength - 1,
          "left-1/2 sm:-translate-x-1/2":
            displayIndex > 0 && displayIndex < selectedColumnsLength - 1,
          "!w-1/2": selectedColumnsLength === 2,
        }
      )}
    >
      {availableColumns.map((availableColumnIndex, index) => {
        const item = data[0][availableColumnIndex]
        return (
          <button
            key={item}
            onClick={() => {
              onSelectColumn(availableColumnIndex)
            }}
            className="flex flex-col"
          >
            {index === 0 && (
              <hr
                className={classNames(
                  "hidden w-full sm:block",
                  theme === "light" ? "border-charcoal/10" : "border-charcoal"
                )}
              />
            )}
            <div
              className={classNames(
                "flex h-[72px] cursor-pointer items-center gap-16 px-8"
              )}
            >
              {columnImages && columnImages[availableColumnIndex] && (
                <div className="ml-8 aspect-square h-32 w-32 sm:h-64 sm:w-64">
                  <GatsbyStoryblokImage
                    aspectRatio="fullWidth"
                    image={extractFromTag(
                      columnImages[availableColumnIndex],
                      "image"
                    )}
                    alt={
                      item.match(TableRegex.PRODUCT)
                        ? item.match(TableRegex.PRODUCT)![1]
                        : ""
                    }
                    className="h-32 w-32 sm:h-64 sm:w-64 md:h-full md:w-auto"
                    testId="comparison-table-image"
                    imageObjectFit="contain"
                  />
                </div>
              )}
              <Typography
                font="grotesk"
                weight="medium"
                color={getThemeColor(theme)}
                size="body-lg"
                text={
                  item.match(TableRegex.PRODUCT)
                    ? item.match(TableRegex.PRODUCT)![1]
                    : ""
                }
                className={CELL_TEXT_CLASSSES}
              />
            </div>
            {index !== availableColumns.length - 1 && (
              <hr
                className={classNames(
                  "w-full",
                  theme === "light" ? "border-charcoal/10" : "border-charcoal"
                )}
              />
            )}
          </button>
        )
      })}
    </div>
  )
}

export default HeaderDropdown
